import { Grid, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const GenetecCardHolderIcon = () => {
  const [isShown, setIsShown] = React.useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Tooltip title={t("Cardholder Group")}>
        <Grid
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          {isShown ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <g id="card_holder_group" transform="translate(16667 -7127)">
                <rect
                  id="Rectangle_9724"
                  data-name="Rectangle 9724"
                  width="30"
                  height="30"
                  transform="translate(-16667 7127)"
                  fill="#fff"
                  opacity="0"
                />
                <path
                  id="Union_535"
                  data-name="Union 535"
                  d="M12.933,22.331l-.475.3a3,3,0,0,1-3.179,0l-4.725-2.97A9.742,9.742,0,0,1,0,11.416V5.255A3,3,0,0,1,2.053,2.408L7.786.5a9.789,9.789,0,0,1,6.161,0L19.682,2.41a3,3,0,0,1,2.053,2.848v6.16a9.788,9.788,0,0,1-.346,2.565,6,6,0,1,1-8.456,8.349Zm.317-3.578a4.5,4.5,0,1,0,4.5-4.5A4.505,4.505,0,0,0,13.25,18.753ZM8.258,1.922,2.527,3.832A1.5,1.5,0,0,0,1.5,5.256v6.16a8.244,8.244,0,0,0,3.853,6.977l4.722,2.967a1.5,1.5,0,0,0,1.586,0l.533-.335q.055.134.117.265a6.018,6.018,0,0,1-.036-4.992H8.837a1.723,1.723,0,0,1-1.389-2.74l.006-.008a4.842,4.842,0,0,1,3.753-1.929h.036a4.842,4.842,0,0,1,3.683,1.837,6.01,6.01,0,0,1,5.577-.036q-.229-.118-.468-.217a8.235,8.235,0,0,0,.2-1.787V5.258a1.5,1.5,0,0,0-1.027-1.425L13.474,1.921a8.294,8.294,0,0,0-5.216,0Zm4.071,19.406,0-.005ZM9.8,13.488a3.349,3.349,0,0,0-1.139.957.211.211,0,0,0-.04.11.219.219,0,0,0,.105.208.21.21,0,0,0,.116.033h4.4a6.035,6.035,0,0,1,.461-.47,3.343,3.343,0,0,0-2.475-1.207A3.368,3.368,0,0,0,9.8,13.488Zm10.857.013h0Zm-.082-.044-.013-.007Zm-.036-.019-.019-.01ZM16.626,21.1a1.225,1.225,0,0,1-.4-.271l-1.277-1.278a.75.75,0,1,1,1.061-1.061L17.1,19.587l2.394-2.393a.75.75,0,0,1,1.06,1.06l-2.58,2.58a1.216,1.216,0,0,1-.4.268,1.231,1.231,0,0,1-.95,0ZM9.2,10.69a2.862,2.862,0,1,1,2.029.842A2.851,2.851,0,0,1,9.2,10.69ZM10.26,7.7a1.367,1.367,0,1,0,.966-.4A1.359,1.359,0,0,0,10.26,7.7Z"
                  transform="translate(-16662.75 7130.247)"
                  fill="#888b8d"
                />
              </g>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <g id="card_holder_group" transform="translate(16667 -7127)">
                <rect
                  id="Rectangle_9724"
                  data-name="Rectangle 9724"
                  width="30"
                  height="30"
                  transform="translate(-16667 7127)"
                  fill="#fff"
                  opacity="0"
                />
                <path
                  id="Union_535"
                  data-name="Union 535"
                  d="M12.933,22.331l-.475.3a3,3,0,0,1-3.179,0l-4.725-2.97A9.742,9.742,0,0,1,0,11.416V5.255A3,3,0,0,1,2.053,2.408L7.786.5a9.789,9.789,0,0,1,6.161,0L19.682,2.41a3,3,0,0,1,2.053,2.848v6.16a9.788,9.788,0,0,1-.346,2.565,6,6,0,1,1-8.456,8.349Zm.317-3.578a4.5,4.5,0,1,0,4.5-4.5A4.505,4.505,0,0,0,13.25,18.753ZM8.258,1.922,2.527,3.832A1.5,1.5,0,0,0,1.5,5.256v6.16a8.244,8.244,0,0,0,3.853,6.977l4.722,2.967a1.5,1.5,0,0,0,1.586,0l.533-.335q.055.134.117.265a6.018,6.018,0,0,1-.036-4.992H8.837a1.723,1.723,0,0,1-1.389-2.74l.006-.008a4.842,4.842,0,0,1,3.753-1.929h.036a4.842,4.842,0,0,1,3.683,1.837,6.01,6.01,0,0,1,5.577-.036q-.229-.118-.468-.217a8.235,8.235,0,0,0,.2-1.787V5.258a1.5,1.5,0,0,0-1.027-1.425L13.474,1.921a8.294,8.294,0,0,0-5.216,0Zm4.071,19.406,0-.005ZM9.8,13.488a3.349,3.349,0,0,0-1.139.957.211.211,0,0,0-.04.11.219.219,0,0,0,.105.208.21.21,0,0,0,.116.033h4.4a6.035,6.035,0,0,1,.461-.47,3.343,3.343,0,0,0-2.475-1.207A3.368,3.368,0,0,0,9.8,13.488Zm10.857.013h0Zm-.082-.044-.013-.007Zm-.036-.019-.019-.01ZM16.626,21.1a1.225,1.225,0,0,1-.4-.271l-1.277-1.278a.75.75,0,1,1,1.061-1.061L17.1,19.587l2.394-2.393a.75.75,0,0,1,1.06,1.06l-2.58,2.58a1.216,1.216,0,0,1-.4.268,1.231,1.231,0,0,1-.95,0ZM9.2,10.69a2.862,2.862,0,1,1,2.029.842A2.851,2.851,0,0,1,9.2,10.69ZM10.26,7.7a1.367,1.367,0,1,0,.966-.4A1.359,1.359,0,0,0,10.26,7.7Z"
                  transform="translate(-16662.75 7130.247)"
                  fill="#888b8d"
                />
              </g>
            </svg>
          )}
        </Grid>
      </Tooltip>
    </>
  );
};
export default GenetecCardHolderIcon;
